import { type ConsentStatus } from "../types/api.js";
import { withCSRF } from "./_csrf.js";

export async function getConsentStatus(): Promise<ConsentStatus> {
  const res = await fetch("/api/consent/status", { credentials: "include" });
  if (!res.ok) throw new Error(`consent.status: ${res.status}`);
  return res.json() as Promise<ConsentStatus>;
}

export async function acceptConsent(currentSha: string): Promise<void> {
  // Backend contract: POST /api/consent with {"text_hash": "<sha>"}.
  // Server returns 204 No Content on success and sets the consent_ack cookie.
  const res = await fetch("/api/consent", {
    method: "POST",
    credentials: "include",
    headers: withCSRF({ "Content-Type": "application/json" }),
    body: JSON.stringify({ text_hash: currentSha }),
  });
  if (!res.ok) throw new Error(`consent.accept: ${res.status}`);
}
